import { AdvancedSettings } from '../models/advanced-settings.model';

export const advancedSettingsDefaultValues: AdvancedSettings = {
  alwaysPullImage: true,
  startupCommand: '',
  startupCommands: [],
  containerArgs: '',
  workingDir: '',
};
